module.exports = __webpack_public_path__ + "static/media/vodavone-ic.feb9e90d.svg";